import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class TopBarNew extends Component {
  state = {
    user: {},
    type: "",
    avatarURL: "",
    config: this.props.config || {},
    breadcrumb: null,
  };

  componentWillMount() {
    let { config } = this.props;
    console.log("TopBarNew config:", config)
    if (config) {
      let { user, type } = config;
      if (user && user.avatar_url && user.avatar_url.length > 0) {
        this.setState((state) => ({
          ...state,
          avatarURL: `${user.avatar_url}?${user.sas_token}&t${new Date().getTime()}`,
          user,
          type,
          config,
        }));
      } else if (user) {
        let avatarURL = `/images/${user.first_name?.[0].toLowerCase()}.PNG`;
        this.setState((state) => ({
          ...state,
          avatarURL: avatarURL,
          user,
          type,
          config,
        }));
      }
    }
  }

  render() {
    let { config } = this.props;
    let { user, type } = this.state;

    if (!config || !config.options) {
      return (
        <div
          className="top-bar"
          style={{
            display: "flex",
            gap: "2rem",
            paddingLeft: "20px",
            alignItems: "center",
            paddingRight: "300px",
            paddingTop: "10px",
            paddingBottom: "10px",
            position: "sticky",
            top: 0,
            background: "#fff",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          ></div>
        </div>
      );
    }

    return (
      <div
        className="top-bar"
        style={{
          display: "flex",
          gap: "2rem",
          paddingLeft: "20px",
          alignItems: "center",
          paddingRight: "300px",
          paddingTop: "10px",
          paddingBottom: "10px",
          position: "sticky",
          top: 0,
          background: "#fff",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          {/* Breadcrumb */}
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {config.options
              .filter((el) => el.text !== "Help")
              .map((el) => {
                if (el.text !== "hr") {
                  el.text = el.text.replace(/\b[a-z]/g, (match) =>
                    match.toUpperCase()
                  );
                }
                return el;
              })
              .map((item, index, arr) => {
                const isLast = index === arr.length - 1; // highlight last breadcrumb
                return item.text === "hr" ? (
                  <div
                    key={`hr-${index}`}
                    style={{
                      width: "1px",
                      height: "20px",
                      backgroundColor: "#e0e0e0",
                    }}
                  />
                ) : (
                  <React.Fragment key={item.path || index}>
                    <Link
                      to={{
                        pathname: item.path,
                        state: { ...item.state, config, sidebarMode: config.mode, user, type, rowData: item.rowData, breadcrumb: this.state.config.breadcrumb || [], collectionData: item.collectionData || null },
                      }}
                      style={{
                        textDecoration: "none",
                        color: isLast ? "#2989CF" : "#666",
                        fontWeight: isLast ? "500" : "400",
                        fontSize: "14px",
                      }}
                    >
                      {item.text}
                    </Link>
                    {!isLast && (
                      <span style={{ margin: "0 4px", color: "#999" }}>/</span>
                    )}
                  </React.Fragment>
                );
              })}
          </div>
        </div>
      </div>
    );
  }
}
